<template>
  <layouts-header></layouts-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />
  <coach-settings-tabset></coach-settings-tabset>
  <div class="content court-bg">
    <div class="container">
      <div class="row">
        <!-- Wallet Balance -->
        <div class="col-md-12 col-lg-5 d-flex">
          <div class="wallet-wrap flex-fill">
            <div class="wallet-bal">
              <div class="wallet-img">
                <div class="wallet-amt">
                  <h5>Your Wallet Balance</h5>
                  <h2>$4,544</h2>
                </div>
              </div>
              <div class="payment-btn">
                <a
                  href="javascript:void(0);"
                  class="btn balance-add"
                  data-bs-toggle="modal"
                  data-bs-target="#add-payment"
                  >Add Payment</a
                >
                <a href="javascript:void(0);" class="btn btn-transfer">Transfer</a>
              </div>
            </div>
            <ul>
              <li>
                <h6>Total Credit</h6>
                <h3>$350.40</h3>
              </li>
              <li>
                <h6>Total Debit</h6>
                <h3>$50.40</h3>
              </li>
              <li>
                <h6>Total transaction</h6>
                <h3>$480.40</h3>
              </li>
            </ul>
          </div>
        </div>
        <!-- /Wallet Balance -->

        <!-- Wallet Card -->
        <div class="col-md-12 col-lg-7 d-flex">
          <div class="your-card">
            <div class="your-card-head">
              <h3>Your Cards</h3>
              <a
                href="javascript:;"
                class="btn btn-secondary d-inline-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#add-new-card"
                >Add New Card</a
              >
            </div>
            <div class="debit-card-blk">
              <div class="debit-card-balence">
                <span>Debit card</span>
                <h5>Balance in card : 1,234</h5>
                <div class="card-number">
                  <h4>123145546655</h4>
                </div>
              </div>
              <div class="debit-card-img">
                <img src="@/assets/img/icons/visa-icon.svg" alt="Icon" />
              </div>
            </div>
          </div>
        </div>
        <!-- /Wallet Card -->
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="court-tab-content">
            <div class="card card-tableset">
              <div class="card-body">
                <div class="coache-head-blk">
                  <div class="row align-items-center">
                    <div class="col-lg-5">
                      <div class="court-table-head">
                        <h4>Transaction</h4>
                        <p>
                          Digital wallets facilitate secure payments for coaching
                          services.
                        </p>
                      </div>
                    </div>
                    <div class="col-lg-7">
                      <div class="table-search-top invoice-search-top">
                        <div id="tablefilter">
                          <div class="dataTables_filter">
                              <label> 
                                  <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                              </label>
                          </div>
                      </div>
                        <div class="sortby-section invoice-sort">
                          <div class="sorting-info">
                            <div class="sortby-filter-group court-sortby">
                              <div class="sortbyset week-bg me-0">
                                <div class="sorting-select">
                                  <vue-select
                                    :options="CoachWeek"
                                    id="coachweek"
                                    placeholder="This Week"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="request-coach-list select-filter">
                          <div class="sortby-filter-group court-sortby">
                            <div class="sortbyset m-0">
                              <div class="sorting-select">
                                <vue-select
                                  :options="CoachTrans"
                                  id="coachTrans"
                                  placeholder="Transaction"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive table-datatble">
                  <a-table class="table datatable" :columns="columns" :data-source="data">
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'RefID'">
                        <div>
                          <router-link to="/coaches/invoice" class="text-primary">{{
                            record.RefID
                          }}</router-link>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'TransactionFor'">
                        <h2 class="table-avatar">
                          <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"
                            ><img
                              class="avatar-img"
                              :src="require(`@/assets/img/${record.Image}`)"
                              alt="User"
                          /></a>
                          <span class="table-head-name flex-grow-1">
                            <a href="javascript:void(0);">{{ record.TransactionFor }}</a>
                          </span>
                        </h2>
                      </template>
                      <template v-else-if="column.key === 'Date'">
                        <div class="table-date-time">
                          <h4>
                            {{ record.Date }}<span>{{ record.Time }}</span>
                          </h4>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'Payment'">
                        <div>
                          <span class="pay-dark fs-16">{{ record.Payment }}</span>
                        </div>
                      </template>

                      <template v-else-if="column.key === 'Status'">
                        <span :class="record.Class"
                          ><i class="feather-check-square me-1"></i
                          >{{ record.Status }}</span
                        >
                      </template>
                      <template v-else-if="column.key === 'action'">
                        <div class="text-end">
                          <div class="dropdown dropdown-action table-drop-action">
                            <a
                              href="javascript:void(0);"
                              class="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              ><i class="fas fa-ellipsis-h"></i
                            ></a>
                            <div class="dropdown-menu dropdown-menu-end">
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-briefcase"></i>Refund</a
                              >
                              <a class="dropdown-item" href="javascript:void(0);"
                                ><i class="feather-trash"></i>Delete</a
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
            <div class="tab-footer">
              <div class="row">
                <div class="col-md-6">
                  <div id="tablelength">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Show
                        <select class="custom-select custom-select-sm form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="-1">All</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div id="tablepage">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination">
                        <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                            class="page-link"><i class="feather-chevrons-left"></i></a></li>
                        <li class="paginate_button page-item active"><a href="javascript:void(0);"
                            aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a></li>
                        <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                            class="page-link"><i class="feather-chevrons-right"></i></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
  <coach-wallet-modal></coach-wallet-modal>
</template>
<script>
const columns = [
  {
    title: "RefID",
    dataIndex: "RefID",
    key: "RefID",
    sorter: {
      compare: (a, b) => {
        a = a.RefID.toLowerCase();
        b = b.RefID.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Transaction For",
    dataIndex: "TransactionFor",
    key: "TransactionFor",
    sorter: {
      compare: (a, b) => {
        a = a.TransactionFor.toLowerCase();
        b = b.TransactionFor.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    RefID: "#CO14",
    TransactionFor: "Kevin Anderson",
    Date: "Mon, Jul 11",
    Time: "04:00 PM - 06:00 PM",
    Payment: "$150",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "profiles/avatar-01.jpg",
  },
  {
    RefID: "#CO15",
    TransactionFor: "Angela Roudrigez",
    Date: "Mon, Jul 11",
    Time: "01:00 PM - 04:00 PM",
    Payment: "$200",
    Status: "Pending",
    Class: "badge bg-info",
    Image: "profiles/avatar-06.jpg",
  },
  {
    RefID: "#CO16",
    TransactionFor: "Wing Sports Academy",
    Date: "Mon, Jul 11",
    Time: "05:00 PM - 08:00 PM",
    Payment: "$150",
    Status: "Failed",
    Class: "badge bg-danger",
    Image: "booking/booking-03.jpg",
  },
  {
    RefID: "#CO17",
    TransactionFor: "Feather Badminton",
    Date: "Mon, Jul 11",
    Time: "01:00 PM - 04:00 PM",
    Payment: "$90",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "booking/booking-04.jpg",
  },
  {
    RefID: "#CO18",
    TransactionFor: "Pete Hill",
    Date: "Mon, Jul 11",
    Time: "03:00 PM - 08:00 PM",
    Payment: "$180",
    Status: "Paid",
    Class: "badge bg-success",
    Image: "profiles/avatar-07.jpg",
  },
];
export default {
  data() {
    return {
      data,
      columns,
      title: "Requests",
      text: "Home",
      text1: "Requests",
      CoachWeek: ["This Week", "One Day"],
      CoachTrans: ["All Transaction", "One Month", "Two Month"],
    };
  },
};
</script>
